export class CreatePfacModel {
    cnpj: string;
    name: string;    
}

export class PfacModel {
    id: number;
    cnpj: string;
    name: string;
    active: boolean;
    createAt: string;
}

export class SearchPfacModel {
    size: string;
    pageNumber: string;
}

export class UpdatePfacModel {
    name: string;
    active: boolean;
}

export class AuditPfacModel {
    id: number;
    cnpj: string;
    name: string;
    documentUser: string;
    nameUser: string;
    actionDateTime: string;
    active: boolean;
    action: string;
}
